import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';

// Assets
import { ReactComponent as FavoritesIcon } from '../../../../assets/images/svg/favorites-icon.svg';
// import { ReactComponent as SubscribeIcon } from '../../../../assets/images/svg/subscribe.svg';
import './ToolBar.scss';
import { useTranslation } from 'react-i18next';

import { GROUP_NAME_EXTERNAL } from '../../../../constants/configuration.js';

// Components
import SearchBarContainer from '../../../../containers/SearchBarContainer';
import AvatarContainer from '../../../../containers/AvatarContainer';
import ProfileDropdownContainer from '../../../../containers/ProfileDropdownContainer';

const ToolBar = ({ isAuthorized, location, user, isLoading, isUserInternal, isDesktop }) => {
  const { t } = useTranslation();

  return (
    <ul className="ToolBar">
      {isAuthorized && isDesktop && user?.groups && user?.groups[0].name === GROUP_NAME_EXTERNAL ? (
        <li className="ToolBar__tariffs" style={{ marginRight: 0 }}>
          <Link className="ToolBar__unfilled" to="/tariffs">{t('header.tariffsBtn')}</Link>
        </li>
      ) : null}
      {isAuthorized && (
        <li className="ToolBar__item ToolBar__favorites">
          <NavLink to="/favorites">
            <FavoritesIcon />
            <span>{t('header.toolbar.watch')}</span>
          </NavLink>
        </li>
      )}
      {/* {isAuthorized && isDesktop && user?.groups?.[0].name === GROUP_NAME_EXTERNAL && (
        <li className="ToolBar__item ToolBar__subscribe">
          <Link to="/subscribe">
            <SubscribeIcon />
            <span>{t('header.toolbar.subscribe')}</span>
          </Link>
        </li>
      )} */}
      <li className="ToolBar__search">
        <SearchBarContainer />
      </li>
      {!isAuthorized && !isUserInternal && isLoading && (
        <li className="ToolBar__tariffs">
          <Link to="/tariffs">{t('header.tariffsBtn')}</Link>
        </li>
      )}
      <li className="ToolBar__login">
        {isAuthorized ? (
          <>
            {isDesktop ? (
              <>
                <Link className="ToolBar__avatar" to="/profile">
                  <AvatarContainer />
                </Link>
                <ProfileDropdownContainer />
              </>
            ) : (
              <Link className="ToolBar__avatar" to="/profile">
                <AvatarContainer />
              </Link>
            )}
          </>
        ) : (
          <Link
            className="ToolBar__enter"
            to={{
              pathname: '/auth/login',
              state: { background: location }
            }}
          >
            {t('header.loginBtn')}
          </Link>
        )}
      </li>
    </ul>
  );
};

ToolBar.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  statusIsAuthorized: PropTypes.bool.isRequired,
  isUserInternal: PropTypes.bool.isRequired,
  user: PropTypes.object,
  location: PropTypes.object.isRequired
};

export default ToolBar;
